import {
  doc,
  onSnapshot,
  FirestoreError,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../firebase";
import { EntityGet, EntityServerGet, OnSnapshotDocService } from "../types";
import { Inbox } from "./types";
import { transformMetadata, processTimestampFields } from "../utils";

export type InboxOnSnapshotDocService<T> = (
  id: string,
  callback: (doc: T) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotDoc: InboxOnSnapshotDocService<EntityGet<Inbox>> = (
  id,
  callback,
  onError
) => {
  const docRef = doc(db, `/inbox/${id}`);
  return onSnapshot(
    docRef,
    (docSnap) => {
      if (docSnap.exists()) {
        callback(
          processTimestampFields(
            transformMetadata(
              {
                ...docSnap.data(),
                id: docSnap.id,
              } as EntityServerGet<Inbox>,
              docSnap.metadata
            )
          ) as EntityGet<Inbox>
        );
      } else {
        onError?.({
          name: "FirestoreError",
          code: "not-found",
          message: `Document "${id}" was not found`,
        });
      }
    },
    onError
  );
};

export default onSnapshotDoc;
